module.exports = __webpack_public_path__ + "img/thumb-deiwert.d21afd3f.jpg";